module.exports = __webpack_public_path__ + "static/img/icon_ticket.97c614bf.svg";